import { createContext, useContext } from 'react'

const SidebarContext = createContext(false)

export function SidebarProvider({ children }: { children: React.ReactNode }) {
  return (
    <SidebarContext.Provider value={true}>{children}</SidebarContext.Provider>
  )
}

export function useHasSidebar() {
  return useContext(SidebarContext)
}

export function LoadingLogo() {
  return (
    <div className="flex flex-col items-center gap-3">
      <img
        src="/images/logos/vixiees_logo.svg"
        alt="Loading"
        className="size-12 dark:hidden"
      />
      <img
        src="/images/logos/vixiees_white_logo.svg"
        alt="Loading"
        className="hidden size-12 dark:block"
      />
      <div className="flex gap-1.5">
        <span className="size-2 rounded-full bg-primary animate-bounce [animation-delay:0ms]" />
        <span className="size-2 rounded-full bg-primary animate-bounce [animation-delay:150ms]" />
        <span className="size-2 rounded-full bg-primary animate-bounce [animation-delay:300ms]" />
      </div>
    </div>
  )
}

export function LoadingScreen() {
  return (
    <div className="flex h-screen">
      <div className="w-60 shrink-0 bg-[#1a1b2e]" />
      <div className="flex flex-1 items-center justify-center">
        <LoadingLogo />
      </div>
    </div>
  )
}
